import { ofType } from 'redux-observable';
import { switchMap, mergeMap } from 'rxjs/operators';

import {
    fetchCardAccount as fetchCardAccountAction,
    replaceCardAccount,
    resetCardAccount,
    setCardAccountError,
} from '@perpay-web/fintech/actions/entities/cardAccounts';
import { CARD_ACCOUNTS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { cardMigrationModalSetIsModalOpen } from '@perpay-web/fintech/hooks/useCardMigrationContext';
import { handleErrorMessageWithFallback } from '@perpay-web/observable/operators/handleErrorMessageWithFallback';

export const fetchCardAccount = (action$, state$, { get }) =>
    action$.pipe(
        ofType(fetchCardAccountAction().type),
        switchMap(() => get(CARD_ACCOUNTS_ENDPOINT)),
        mergeMap((results) => {
            const cardAccount = results.response;
            if (!cardAccount) return [resetCardAccount()];

            const returnActions = [replaceCardAccount({ all: cardAccount })];

            if (cardAccount[0].reshipEligible && cardAccount[0].uuid) {
                returnActions.push(cardMigrationModalSetIsModalOpen(true));
            }
            return returnActions;
        }),
        handleErrorMessageWithFallback((error) => [setCardAccountError(error)]),
    );
